module.exports = __webpack_public_path__ + "static/media/LIV_WhiteLogo.a9ef33fc.svg";